import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {EventSpendTypeBO} from "./EventSpendTypeBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";

export class EventSpendTypeBOAudit {

    // Audit Log Service for User Group

    static async EventSpendTypeAuditBO(EventSpendTypeBO: EventSpendTypeBO): Promise<AuditService> {
        const self = EventSpendTypeBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("EventSpendType", self.drWB_EventSpendType.cif.WB_EVTSTYPE_ID)


        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys


        // Spend Type properties
        const spendTypeParams: IAuditField [] = [
            {fieldName: "SPENDTYPE_ID", realName: "Spend Type ID", bAllMsg: true},
            {fieldName: "SPEND_TYPE_NAME", realName: "Spend Type Name", bAllMsg: true},
            {fieldName: "ACTIVE_IND", realName: "Active Ind", booleanIndField: true},
            {fieldName: "MANUAL_IND", realName: "Manual Ind", booleanIndField: true},
            {fieldName: "SOURCE_ID", realName: "Source"},
            {fieldName: "RATE_LEVEL", realName: "Rate Level", domainId: "SpendRateLevel"},
            {fieldName: "RATEBASIS_SHOW_IND", realName: "Show Rate Basis", booleanIndField: true},
            {fieldName: "RATEBASIS_DEFAULT", realName: "Rate Basis Default", domainId: "RateBasis"},
            {fieldName: "RATEBASIS_OPTIONS", realName: "Rate Basis Options"},
            {fieldName: "RATEUOM_SHOW_IND", realName: "Show Rate UOM", booleanIndField: true},
            {fieldName: "RATEUOM_DEFAULT", realName: "Rate UOM Default", domainId: "RateUOM"},
            {fieldName: "RATEUOM_OPTIONS", realName: "Rate UOM Options"},
            {fieldName: "MARGIN_CALCULATOR_SHOW_IND", realName: "Show Margin Calculator", booleanIndField: true},
            {fieldName: "PAYMENTMETHOD_SHOW_IND", realName: "Show Payment Method", booleanIndField: true},
            {fieldName: "PAYMENTMETHOD_DEFAULT", realName: "Payment Method Default", domainId: "PaymentMethod"},
            {fieldName: "PAYMENTMETHOD_OPTIONS", realName: "Payment Method Options"},
            {fieldName: "FUNDTYPE_SHOW_IND", realName: "Show Fund Type", booleanIndField: true},
            {fieldName: "FUNDTYPE_DEFAULT", realName: "Fund Type Default", ...auditFieldFK.fundType},
            {fieldName: "FUNDTYPE_OPTIONS", realName: "Fund Type Options"},
            {fieldName: "REDEMPTIONRATE_SHOW_IND", realName: "Show Redemption Rate", booleanIndField: true},
            {fieldName: "REDEMPTIONRATE_LEVEL", realName: "Redemption Rate Level", domainId: "EvtSRedemptionRateLevel"},
            {fieldName: "PRDVOLBASIS_SHOW_IND", realName: "Show Prd Volume Basis", booleanIndField: true},
            {fieldName: "PRDVOLBASIS_BB_DEFAULT", realName: "BB Prd Vol Basis Default", domainId: "RatePrdVolBasis"},
            {fieldName: "PRDVOLBASIS_BB_OPTIONS", realName: "BB Prd Vol Basis Options"},
            {fieldName: "PRDVOLBASIS_OI", realName: "OI Prd Vol Basis", domainId: "RatePrdVolBasis"},
            {fieldName: "PRDVOLBASIS_REBATE", realName: "Rebate Prd Vol Basis", domainId: "RatePrdVolBasis"},
            {fieldName: "SOP_BB_RATE_SHOW_IND", realName: "Show Sum of Parts BB Rate", booleanIndField: true},
            {fieldName: "SOP_OI_OS_RATE_SHOW_IND", realName: "Show Sum of Parts OS OI Rate", booleanIndField: true},
            {fieldName: "SOP_OI_COMP_RATE_SHOW_IND", realName: "Show Sum of Parts Comp OI Rate", booleanIndField: true},
            {fieldName: "WORKFLOW_SHOW_IND", realName: "Use Workflow", booleanIndField: true},
            {fieldName: "WORKFLOW_POLICY", realName: "Workflow Policy", domainId: "EvtWorkflowPolicy"},
            {fieldName: "WB_WORKFLOW_ID", realName: "Workflow", ...auditFieldFK.workflow},
            {fieldName: "CUSTPMT_WORKFLOW_SHOW_IND", realName: "Show Customer Pmt Workflow", booleanIndField: true},
            {fieldName: "CUSTPMT_WORKFLOW_ID", realName: "Customer Pmt Workflow", ...auditFieldFK.workflow},
            {fieldName: "NAME_SHOW_IND", realName: "Show Name", booleanIndField: true},
            {fieldName: "MAINTABGRID", realName: "Main Grid", domainId: "EvtSMainTabGrid"},
            {
                fieldName: "PRODUCTGROUP_SYNC_POLICY",
                realName: "Product Group Sync Policy",
                domainId: "EvtSPrdGrpSyncPolicy"
            },
            {fieldName: "PRODUCTGROUP_INCL_SHOW_IND", realName: "Show Product Group Include", booleanIndField: true},
            {fieldName: "PRODUCTGROUP_SUMMARY_SHOW_IND", realName: "Show Product Group Summary", booleanIndField: true},
            {fieldName: "PRODUCT_SYNC_POLICY", realName: "Product Sync Policy", domainId: "EvtSPrdSyncPolicy"},
            {fieldName: "PRODUCT_SUMMARY_SHOW_IND", realName: "Show Product Summary", booleanIndField: true},
            {fieldName: "PRODUCT_INCL_SHOW_IND", realName: "Show Product Include", booleanIndField: true},
            {fieldName: "DISPLAY_BUOM_QTY_SHOW_IND", realName: "Show BaseUOM Qty", booleanIndField: true},
            {fieldName: "DISPLAY_QTY_SHOW_IND", realName: "Show Display Qty", booleanIndField: true},

            {fieldName: "PAYMENTS_SHOW_IND", realName: "Show Payment Tab", booleanIndField: true},
            {fieldName: "OFFINVOICELOG_SHOW_IND", realName: "Show Off Invoice Log", booleanIndField: true},
            {fieldName: "COMMENTS_SHOW_IND", realName: "Show Comments Log", booleanIndField: true},
            {fieldName: "SUBCUSTOMER_SHOW_IND", realName: "Show SubCustomer", booleanIndField: true},
            {fieldName: "GROSSLISTPRICE_SHOW_IND", realName: "Show Gross List Price", booleanIndField: true},
            {fieldName: "NETLISTPRICE_SHOW_IND", realName: "Show List Price", booleanIndField: true},
            {fieldName: "PAIDINFULL_SHOW_IND", realName: "Show Paid In Full", booleanIndField: true},

            {fieldName: "INSTOREDATES_SHOW_IND", realName: "Show InStore Dates", booleanIndField: true},
            {fieldName: "INSTOREDATES_POLICY", realName: "InStore Date Policy", domainId: "EvtSInStoreDatePolicy"},
            {fieldName: "SHIPMENTDATES_SHOW_IND", realName: "Show Shipment Dates", booleanIndField: true},
            {fieldName: "SHIPMENTDATES_POLICY", realName: "Shipment Date Policy", domainId: "EvtSShipmentDatePolicy"},
            {fieldName: "DISTRIBUTIONDATES_SHOW_IND", realName: "Show Distribution Dates", booleanIndField: true},
            {
                fieldName: "DISTRIBUTIONDATES_POLICY",
                realName: "Distribution Dates Policy",
                domainId: "EvtSDistributionDatePolicy"
            },
            {fieldName: "ORDERDATES_SHOW_IND", realName: "Show Order Dates", booleanIndField: true},
            {fieldName: "ORDERDATES_POLICY", realName: "Order Dates Policy", domainId: "EvtSOrderDatePolicy"},

            {fieldName: "CNDM_ID_SHIPDIR_OFFSET", realName: "Direct Shipment Offset", ...auditFieldFK.conditionType},
            {
                fieldName: "CNDM_ID_SHIPDIRDFT_OFFSET",
                realName: "Direct Shipment Offset Dflt", ...auditFieldFK.conditionType
            },
            {fieldName: "CNDM_ID_SHIPIND_OFFSET", realName: "Indirect Shipment Offset", ...auditFieldFK.conditionType},
            {
                fieldName: "CNDM_ID_SHIPINDDFT_OFFSET",
                realName: "Indirect Shipment Offset Dflt", ...auditFieldFK.conditionType
            },
            {fieldName: "CNDM_ID_SHIPPRF_OFFSET", realName: "Performance Date Offset", ...auditFieldFK.conditionType},
            {
                fieldName: "CNDM_ID_SHIPPRFDFT_OFFSET",
                realName: "Performance Date Offset Dflt", ...auditFieldFK.conditionType
            },
            {fieldName: "CNDM_ID_ORDERDT_OFFSET", realName: "Order Date Offset", ...auditFieldFK.conditionType},
            {fieldName: "CNDM_ID_DISTRIBDT_OFFSET", realName: "Distrib Date Offset", ...auditFieldFK.conditionType},

            {fieldName: "RENDER_OPTIONS", realName: "Render Options"},
            {fieldName: "PEA_IND", realName: "PEA flag"},
            {fieldName: "TPM_IND", realName: "TPM flag"},
            {fieldName: "TRADEIND", realName: "Working Trade flag"},
            {fieldName: "CONSUMERDISCOUNTIND", realName: "Consumer Discount flag"},
            {fieldName: "RETAILERMARGININD", realName: "Retailer Margin flag"}
        ]

        const spendTypeAccountParams: IAuditField [] = [
            {fieldName: "WB_GLACCT_ID", realName: "GL Account", bAllMsg: true, ...auditFieldFK.glAccount},
            {fieldName: "PAYMENT_METHOD", realName: "Payment Method", bAllMsg: true, domainId: "PaymentMethod"},
            {fieldName: "WB_FUNDTYPE_ID", realName: "Fund Type", bAllMsg: true, ...auditFieldFK.fundType},
            {fieldName: "GL_EXPENSETYPE_ID", realName: "Expense Type", bAllMsg: true, domainId: "Expense_Type"},
        ]

        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_EventSpendType, spendTypeParams, {
            objectName: 'Spend Type',
            deletedKeys: deleteKeys
        })

        for (let aSpendTypeAccountRow of self.WB_EventSpendType.WB_EventSpendAccounts) {
            await AuditUtils.logRecord(auditService, aSpendTypeAccountRow, spendTypeAccountParams, {
                objectName: 'GL Account Assignment',
                deletedKeys: deleteKeys
            })
        }

        return auditService
    }


    static async DeleteEventSpendType(EventSpendTypeBO: EventSpendTypeBO): Promise<AuditService> {
        try {
            const self = EventSpendTypeBO;
            const auditService = new AuditService(new PAdbContext({}))
            auditService.setReference("EventSpendType", self.drWB_EventSpendType.cif.WB_EVTSTYPE_ID)
            let sUsrName = self.drWB_EventSpendType.cif.SPENDTYPE_ID

            if (!self.WB_EventSpendType.isActive && !self.WB_EventSpendType.isNew()) {
                await auditService.Log(AuditLogType.Delete, 'Event Spend Type Deleted, ' + sUsrName);
                await auditService.Save();
                return auditService;
            }
        } catch (error) {
            console.error("An error occured during adding delete event in audit log");
        }
    }

}
